exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".arrows{max-width:1rem}.arrow{cursor:pointer;user-select:none;color:gray}.arrow:hover{color:#ff4081}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/percent/percentInput/percentInput.scss
// module id = 532
// module chunks = 0